import { traverse } from './traverse';
export function reduce(adf, callback, initial) {
  let result = initial;
  traverse(adf, {
    any: node => {
      result = callback(result, node);
    }
  });
  return result;
}